import React, { useState } from 'react';
import { TextField, InputAdornment, Select, MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const TextFilter = ({ columns, onFilterChange }) => {

    return (
            <TextField
                label={columns.filter(column => column.filtered).map(column => column.label).join(", ")}
                variant="outlined"
                onChange={onFilterChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />
    );
};

export default TextFilter;
